// Copyright 2019 Sorama B.V.

import { SVGNode } from "libraries/SVG/SVGNode";

export enum HorizontalAnchor {
    Left = -1,
    Middle = 0,
    Right = 1,
}

export enum VerticalAnchor {
    Top = -1,
    Middle = 0,
    Bottom = 1,
}

export enum RelativePosition {
    Left,
    Top,
    Right,
    Bottom,
}

export interface ISVGComposer {
    anchor(horizontal: HorizontalAnchor, vertical: VerticalAnchor): ISVGComposer;

    append(node: SVGNode, position: RelativePosition): ISVGComposer;

    remove(part: string): ISVGComposer;

    trim(): ISVGComposer;

    generate(): SVGNode;
}
